const isShowMessageSchema = {
  id: 'isShowMessage',
  title: '是否显示调用【成功/失败】提示,默认显示(true)',
  type: 'boolean',
  default: true,
  enum: [{
    value: true,
    label: '显示'
  }, {
    value: false,
    label: '不显示'
  }],
  required: false,
  description: '<img src="https://vfiles.gtimg.cn/vupload/20210810/f9e6821628564632166.png"/>'
};
export default isShowMessageSchema;
//# sourceMappingURL=isShowMessageSchema.js.map
